import React, { useEffect } from 'react';
import DashboardContent from '@/components/dashboard/DashboardContent';
import useDashboardActions from '@/hooks/useDashboardActions';
import { trackEvent } from '@/lib/analytics';
import { useUser } from '@/lib/contexts/UserContext';
import { AuthDebugger } from '@/components/AuthDebugger';

const Dashboard = () => {
  const {
    handleRunClick,
    handleAlertClick,
    handleAcknowledgeAlert,
    handleCreateTicket
  } = useDashboardActions();
  
  const { user } = useUser();

  useEffect(() => {
    // Check if user exists before tracking
    if (user) {
      // Track dashboard viewed event on page load
      trackEvent('dashboard_viewed', {
        user_role: user.role || 'unknown',
        account_id: user.id || 'unknown',
        has_integrations: Boolean(user.metadata?.has_integrations || false)
      });
    }
  }, [user]);

  return (
    <div>
      <AuthDebugger />
      <DashboardContent
        onRunClick={handleRunClick}
        onAlertClick={handleAlertClick}
        onAcknowledgeAlert={handleAcknowledgeAlert}
        onCreateTicket={handleCreateTicket}
      />
    </div>
  );
};

export default Dashboard;
